import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatNull, formatDate, isDatePastInMoscow } from '../../../Utils/GlobalUtils';

import Modal from '../../Modal';
import EditMainQualification from './Modals/EditMainQualification';

const MainQualificationPanel = ({ userId }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-main-qualification?user_id=${userId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, userId]);

    const [isEditModal, setIsEditModal] = React.useState(false);

    const [isShowSec, setIsShowSec] = React.useState(false);


    return (
        <>
            <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
                <EditMainQualification userId={userId} onSuccess={() => setReload(true)} />
            </Modal>

            <div className='panel linksPanel'>
                <h3>Основная информация</h3>
                <p>Дата сдачи теоретического экзамена по подготовке арбитражных управляющих при Росреестре: <a className={isDatePastInMoscow(formInfo.date_am_exam, 1) ? 'colorCell red' : ''}>{formatDate(formInfo.date_am_exam)} {isDatePastInMoscow(formInfo.date_am_exam, 1) ? '[С последней даты выдачи свидетельства прошел год. Необходимо продлить свидетельство и указать новую дату выдачи]' : ''}</a></p>
                <p>Специальные категории должников: {!loading && formInfo.user_sdc.length===0 ? 'Отсутствуют' : formInfo.user_sdc?.map(userSDC => userSDC.category_name).join(', ')}</p>
                <p>Форма допуска к государственной тайне: {isShowSec ? formatNull(formInfo.admission_form) : <a className='aWithLink' onClick={() => setIsShowSec(true)}>Нажмите, чтобы увидеть</a>}</p>
                <button type='button' className='tableButton' onClick={() => setIsEditModal(true)}>Указать данные о квалификации</button>
            </div>
        </>
    )
}

export default MainQualificationPanel;